import React from 'react';
import { Box, Typography } from '@mui/material';
import SidebarNavItem from '../SidebarNavItem';

const SectionLabel = ({ label, sidebarCollapsed }) => {
  if (sidebarCollapsed) return null;

  return (
    <Typography
      sx={{
        fontSize: '0.6875rem',
        fontWeight: 500,
        color: 'rgba(255,255,255,0.45)',
        letterSpacing: '0.25em',
        px: '0.875rem',
        pt: '1.25rem',
        pb: '0.25rem',
        display: 'block',
        userSelect: 'none',
        textTransform: "uppercase"
      }}
    >
      {label}
    </Typography>
  );
};

const SidebarNavigation = ({
  menuConfig,
  sidebarCollapsed,
  matchesUpMd,
  toggleDrawer,
}) => {
  const commonProps = {
    drawerToggle: !matchesUpMd ? toggleDrawer : undefined,
    collapsed: sidebarCollapsed,
  };

  const hasVisibleItems = (section) => {
    return section && section.some(item => item.permission !== false);
  };

  return (
    <Box
      id="sidebar-scroller"
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        pt: '0.25rem',
        pb: '0.25rem',
      }}
    >
      {menuConfig.home.map((item) => (
        <SidebarNavItem key={item.label} {...item} {...commonProps} />
      ))}

      {hasVisibleItems(menuConfig?.fundraise) && (
        <>
          <SectionLabel label="Fundraise" sidebarCollapsed={sidebarCollapsed} />
          {menuConfig?.fundraise?.map((item) => (
            <SidebarNavItem key={item.label} {...item} {...commonProps} />
          ))}
        </>
      )}

      {hasVisibleItems(menuConfig?.relationships) && (
        <>
          <SectionLabel label="Relationships" sidebarCollapsed={sidebarCollapsed} />
          {menuConfig?.relationships?.map((item) => (
            <SidebarNavItem key={item.label} {...item} {...commonProps} />
          ))}
        </>
      )}

      {hasVisibleItems(menuConfig?.intelligence) && (
        <>
          <SectionLabel label="Intelligence" sidebarCollapsed={sidebarCollapsed} />
          {menuConfig?.intelligence?.map((item) => (
            <SidebarNavItem key={item.label} {...item} {...commonProps} />
          ))}
        </>
      )}
    </Box>
  );
};

export default SidebarNavigation;
